import React, { useEffect, useState } from 'react';
import { Alert, Button, Drawer, Space, Typography } from 'antd';
import { offlineRuntimeEnabled } from './config';
import { startOfflineRuntime, watchOfflineStatus, retryAction } from './runtime';

export default function OfflineStatus() {
  const [state, setState] = useState({ rows: [], issue: '', mode: 'off' });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!offlineRuntimeEnabled) return undefined;
    const stopWatching = watchOfflineStatus(setState);
    const stopRuntime = startOfflineRuntime();
    return () => { stopRuntime(); stopWatching(); };
  }, []);
  if (!offlineRuntimeEnabled || (!state.rows.length && !state.issue)) return null;
  const local = state.rows.filter(action => !action.cloudConfirmed).length;
  return <>
    <Alert style={{ position: 'fixed', bottom: 16, left: 16, zIndex: 1900, maxWidth: 410 }}
      type="warning" showIcon message={`${state.rows.length} clinical save(s) pending`}
      description={state.issue || `${local} awaiting cloud confirmation. Keep the dashboard open to synchronize.`}
      action={<Button onClick={() => setOpen(true)}>Review</Button>} />
    <Drawer title="Clinical saves — offline pilot" open={open} onClose={() => setOpen(false)} width={520}>
      <Typography.Paragraph>Only new complaint, diagnosis and procedure entries are supported. Cloud upload is separate from saving in the patient file.</Typography.Paragraph>
      {state.issue && <Alert type="error" message={state.issue} />}
      {state.rows.map(action => <div key={action.operationId} style={{ borderBottom: '1px solid #ddd', padding: '16px 0' }}>
        <Typography.Text strong>Patient: {action.payload.patient_id}</Typography.Text>
        <div>{new Date(action.createdAt).toLocaleString()}</div>
        <div>{action.status === 'attention' ? 'Needs attention' : action.cloudConfirmed ? 'Uploaded — waiting for backend confirmation' : 'Stored locally — cloud confirmation pending'}</div>
        <Typography.Paragraph style={{ whiteSpace: 'pre-wrap' }}>
          {[action.payload.complaint, action.payload.diagnosis, action.payload.procedure].filter(Boolean).join('\n')}
        </Typography.Paragraph>
        <Space direction="vertical">
          <Typography.Text type="secondary">Action: {action.operationId}</Typography.Text>
          {action.lastErrorCode && <Typography.Text type="danger">{action.lastErrorCode}</Typography.Text>}
          <Button onClick={() => retryAction(action)}>Retry same action</Button>
        </Space>
      </div>)}
    </Drawer>
  </>;
}
